import { Layout } from '@enterprise-ui/canvas-ui-react'
import { RelationshipComponent } from './components/RelationshipComponent'

export const Relationship = () => {
  return (
    <>
      <Layout.Body>
        <RelationshipComponent />
      </Layout.Body>
    </>
  )
}
